import { useEffect, useState, useContext } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import Loading from './Frames/Loading'
import { UserContext } from '../services/Context/UserContext'
import API from '../services/API'
import JWT from '../services/JWT'
import { Alert } from '@mui/material'

export default function Private({children, roles}){

    const {user, setUser} = useContext(UserContext)

    const [status, setStatus] = useState('loading')

    const location = useLocation()


    useEffect(() => {

        if(user){

            if( Array.isArray(roles) ){

                setStatus(user.roles.some(r => roles.includes(r)) ? 'allowed' : 'forbidden')

            }else{

                setStatus('allowed')
            }

        }else if( JWT.hasAccessToken() ){

            API.get('/me')
                .then(r => setUser(r.data))
                .catch(e => setStatus('unlogged'))

        }else if( JWT.hasRefreshToken() ){

            API.get('/refresh', {headers: {Authorization: 'Bearer ' + JWT.getRefreshToken()}})
                .then(r => {
                    JWT.setTokens(r.data)
                    setUser(r.data)
                })
                .catch(e => setStatus('unlogged'))

        }else{

            setStatus('unlogged')
        }


    }, [roles, user, setUser])


    if(status === 'allowed') return children


    if(status === 'forbidden'){

        return <Alert severity="warning">Vous n'êtes pas autorisé à accéder à cette ressource.</Alert>
    }


    if(status === 'unlogged'){

        window.sessionStorage.setItem('targetPath', location.pathname);

        return <Navigate to='/login' />
    }

    return <Loading/>
}